<template>
    <div class="payment-card-container p-3" :class="creditcard ? 'has-hover' : ''">
        <div v-if="creditcard" class="payment-card">
            <div class="payment-card-logo" :style="dynamicStyleLogo"></div>
            <div class="payment-card-number">
                {{ $filters.creditCard(creditcard.last4).toUpperCase() }}
            </div>
            <div class="payment-card-expire-date">
                {{ creditcard.expireDate }}
            </div>
        </div>
        <!-- <div class="mt-3 acenter">
                <a class="link" @click="removeCard">{{ $l10n.__("Supprimer cette carte") }}</a>
            </div> -->

        <div v-else class="payment-card template-add-card">
            <div class="payment-card-add">
                <div class="acenter">
                    <span v-if="validationInProgress">{{ validationMessage }}</span>
                    <span v-else>{{ placeholder }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        creditcard: {
            type: [Object, Boolean],
            required: false,
            default: false,
        },
        validationInProgress: {
            type: Boolean,
            required: false,
            default: false,
        },
        validationMessage: {
            type: String,
            required: false,
            default: '',
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {};
    },
    computed: {
        dynamicStyleLogo() {
            const style = {
                width: '60px',
                height: '45px',
            };
            let logoUrl = '';
            switch (this.creditcard.brand) {
                case 'MasterCard':
                    logoUrl = 'mastercard.png';
                    break;
                case 'Visa':
                    style.height = '30px';
                    logoUrl = 'visa.png';
                    break;
                case 'AmericanExpress':
                    style.width = '80px';
                    style.height = '60px';
                    style.top = '10px';
                    logoUrl = 'american-express.png';
                    break;
                case 'Maestro':
                    logoUrl = 'maestro.png';
                    break;
            }
            if (logoUrl != '') {
                style.backgroundImage =
                    "url('/ressources/logged/img/creditcardslogo/" + logoUrl + "')";
            }

            return style;
        },
    },
};
</script>

<style scoped lang="scss">
.payment-card-container {
    vertical-align: top;
    .payment-card {
        position: relative;
        height: 156px;
        width: 245px;
        background-color: #f4f6f9;
        border-radius: 20px;
        box-shadow: 0px 2px 8px #6c6c6c;
        .payment-card-logo {
            position: absolute;
            height: 45px;
            width: 60px;
            right: 20px;
            top: 20px;
            overflow: hidden;
            background-repeat: round;
        }
        .payment-card-number {
            color: black;
            position: absolute;
            top: 90px;
            font-size: 16px;
            left: 30px;
        }
        .payment-card-expire-date {
            color: black;
            position: absolute;
            top: 120px;
            font-size: 16px;
            right: 30px;
        }
        &.template-add-card {
            background-color: #d8d8e6;
            display: table-cell;
            vertical-align: middle;
            cursor: pointer;
        }
    }
    &.has-hover:hover {
        background-color: #dddee1;
        cursor: pointer;
        border-radius: 5px;
    }
}
</style>
